module.exports = __webpack_public_path__ + "img/qrcode.7cb17dfe.svg";